if (!customElements.get('card-variant-pills')) {
  class CardVariantPills extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const json = this.querySelector('[data-card-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.card = this.closest('.card-wrapper');
      this.image = this.card && this.card.querySelector('.card--image-animate.media img');
      this.source = this.image && this.image.closest('picture') && this.image.closest('picture').querySelector('source');
      if (this.image) {
        this.originalImage = {
          src: this.image.getAttribute('src'),
          srcset: this.image.getAttribute('srcset'),
          sourceSrcset: this.source && this.source.getAttribute('srcset')
        };
      }
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const pill = event.target.closest('.card-variant-pills__pill');
      if (!pill || pill.getAttribute('aria-pressed') === 'true') return;

      const index = pill.dataset.optionIndex;
      this.querySelectorAll(`.card-variant-pills__pill[data-option-index="${index}"]`).forEach((button) => {
        button.setAttribute('aria-pressed', button === pill ? 'true' : 'false');
      });

      const selected = Array.from(this.querySelectorAll('.card-variant-pills__pill[aria-pressed="true"]'))
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((button) => button.dataset.value);
      const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));

      this.updatePrice(variant);
      this.updateButton(variant);
      this.updateBadge(variant);
      this.updateImage(variant);
      this.updateLinks(variant);
    }

    updatePrice(variant) {
      const target = this.card && this.card.querySelector('.card-variant-price');
      const template = variant && this.querySelector(`template[data-variant-price="${variant.id}"]`);
      if (!target || !template) return;
      target.replaceChildren(template.content.cloneNode(true));
    }

    updateButton(variant) {
      const button = this.card && this.card.querySelector('[data-card-variant-atc]');
      if (!button) return;

      const available = Boolean(variant && variant.available);
      if (variant) button.dataset.variantId = variant.id;
      button.classList.toggle('disabled', !available);
      if (available) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }

      const label = button.querySelector('.card-variant-atc__label');
      if (label) label.textContent = available ? button.dataset.labelBuy : button.dataset.labelSoldOut;
    }

    updateBadge(variant) {
      const badge = this.card && this.card.querySelector('[data-card-variant-badge]');
      if (!badge) return;

      const sale = variant ? variant.sale : 0;
      badge.hidden = !(sale > 0);
      if (sale > 0) badge.textContent = `${badge.dataset.label} –${sale}%`;
    }

    updateImage(variant) {
      if (!variant || !this.image) return;

      // Variants without their own image fall back to the product's original card image
      const next = variant.src
        ? { src: variant.src, srcset: variant.srcset, sourceSrcset: variant.srcset }
        : this.originalImage;
      if (this.image.getAttribute('src') === next.src) return;

      this.image.setAttribute('src', next.src);
      if (next.srcset) this.image.setAttribute('srcset', next.srcset);
      if (this.source && next.sourceSrcset) this.source.setAttribute('srcset', next.sourceSrcset);
    }

    updateLinks(variant) {
      if (!variant || !this.card || !this.dataset.baseUrl || this.dataset.baseUrl === '#') return;

      const url = `${this.dataset.baseUrl}?variant=${variant.id}`;
      this.card.querySelectorAll('a.card__media, .card-information > a.full-unstyled-link').forEach((link) => {
        link.href = url;
      });
    }
  }

  customElements.define('card-variant-pills', CardVariantPills);
}
